<script setup lang="ts">
const props = defineProps<{ creator: Creator }>()

const allSpots = props.creator?.maps?.flatMap(map =>
  map.spots?.map(spot => ({ ...spot, map_slug: map.current_slug })) || []
) || []
</script>

<template>
  <section class="spots-container">
    <MPSpotCard v-for="spot in allSpots" :key="spot.id" :spot="spot" :to="`/maps/${spot.map_slug}/spots/${spot.current_slug}`" :show-tier="true" />
  </section>
</template>

<style scoped lang="postcss">
@import '@/assets/css/layouts.pcss';
@import '@/assets/css/breakpoints.pcss';
@import '@/assets/css/typography.pcss';

.spots-container {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;

  @mixin screen xs {
    grid-template-columns: repeat(2, 1fr);
  }

  @mixin screen md {
    grid-template-columns: repeat(3, 1fr);
  };

  @mixin screen lg {
    grid-template-columns: repeat(4, 1fr);
  };
}
</style>
